import ApexLogo from './ApexLogo';
import { LINKS } from '../constants';
import styles from './Footer.module.css';

export default function Footer({ t }) {
  const links = [
    [t.link1, LINKS.channel],
    [t.link2, LINKS.chat],
    [t.link3, LINKS.dex],
    [t.link4, LINKS.buy],
  ];

  return (
    <footer className={styles.footer}>
      <div className={styles.brand}>
        <ApexLogo size={26} glow={false} />
        <span className={styles.copy}>{t.copy}</span>
      </div>
      <nav className={styles.links}>
        {links.map(([label, href]) => (
          <a key={label} href={href} target="_blank" rel="noopener noreferrer" className={styles.link}>
            {label}
          </a>
        ))}
      </nav>
    </footer>
  );
}
